import axios from 'axios';
import {
  ACCESS_TOKEN_KEY,
  LEGACY_ACCESS_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  ADMIN_USER_KEY,
} from '../utils/admin';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.gatherly.today';

export const getStoredAccessToken = () =>
  localStorage.getItem(ACCESS_TOKEN_KEY) || localStorage.getItem(LEGACY_ACCESS_TOKEN_KEY);

export const clearStoredAuth = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(LEGACY_ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(ADMIN_USER_KEY);
};

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = getStoredAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const requestUrl = error.config?.url || '';
    const isAuthRoute = requestUrl.includes('/api/admin/auth/');

    if (error.response?.status === 401 && !isAuthRoute) {
      clearStoredAuth();

      if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event('admin-auth-logout'));

        if (!window.location.pathname.startsWith('/login')) {
          window.location.replace('/login');
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api;
